export default "__VITE_ASSET__4k36hjjo__"